export const EstateCypressAttribute = {
  buttons: {
    CLOSE_ESTATE: 'EstateCypressAttribute:CLOSE_ESTATE',
    CLEAR_VAULT_SUMMARY: 'EstateCypressAttribute:CLEAR_VAULT_SUMMARY',
    CLEAR_ESTATE_SUMMARY: 'EstateCypressAttribute:CLEAR_ESTATE_SUMMARY',
    ESTATE_DEMO_SEEDING: 'EstateCypressAttribute:ESTATE_DEMO_SEEDING',
    ESTATE_SETTINGS: 'EstateCypressAttribute:ESTATE_SETTINGS',
    GET_STARTED: 'EstateCypressAttribute:buttons:GET_STARTED',
    ADD_MEMBER: 'EstateCypressAttribute:ADD_MEMBER',
    ADD_FLINKS_ACCOUNT: 'EstateCypressAttribute:ADD_FLINKS_ACCOUNT',
    BILLING_VIEW_DEAL: 'EstateCypressAttribute:BILLING_VIEW_DEAL',
    REFRESH_BALANCE: 'EstateCypressAttribute:REFRESH_BALANCE',
    ESTATE_REPORT: 'EstateCypressAttribute:ESTATE_REPORT',
    ESTATE_PLAN_MEMO: 'EstateCypressAttribute:buttons:ESTATE_PLAN_MEMO',
    ADD_EXECUTOR: 'EstateCypressAttribute:buttons:ADD_EXECUTOR'
  },
  inputs: {},
  tour: {
    buttons: {
      NEXT: 'EstateCypressAttribute:tour:buttons:NEXT',
      PREVIOUS: 'EstateCypressAttribute:tour:buttons:PREVIOUS',
      CLOSE: 'EstateCypressAttribute:tour:buttons:CLOSE'
    }
  },
  views: {
    VIEW_CLEAR_ESTATE_SUMMARY_CARD: 'EstateCypressAttribute:views:VIEW_CLEAR_ESTATE_SUMMARY_CARD',
    PLAN_INFORMATION_WILL_MILESTONE: 'EstateCypressAttribute:views:PLAN_INFORMATION_WILL_MILESTONE',
    PLAN_INFORMATION_INVENTORY_MILESTONE:
      'EstateCypressAttribute:views:PLAN_INFORMATION_INVENTORY_MILESTONE',
    PLAN_INFORMATION_DISTRIBUTION_PLAN_MILESTONE:
      'EstateCypressAttribute:views:PLAN_INFORMATION_DISTRIBUTION_PLAN_MILESTONE',
    CONSENT_TRUE_CERTIFIED_COPY_PLACEHOLDER:
      'EstateCypressAttribute:views:CONSENT_TRUE_CERTIFIED_COPY_PLACEHOLDER',
    CONSENT_TRUE_CERTIFIED_COPY_DOCUMENT:
      'EstateCypressAttribute:views:CONSENT_TRUE_CERTIFIED_COPY_DOCUMENT',
    CONSENT_TRUE_CERTIFIED_COPY_NOTE:
      'EstateCypressAttribute:views:CONSENT_TRUE_CERTIFIED_COPY_NOTE',
    CONSENT_TRUE_CERTIFIED_COPY_PENDING_DOCUMENT:
      'EstateCypressAttribute:views:CONSENT_TRUE_CERTIFIED_COPY_PENDING_DOCUMENT',
    TAG: 'EstateCypressAttribute:views:TAG',
    ESTATE_AVATAR: 'EstateCypressAttribute:views:views:ESTATE_AVATAR',
    HUBSPOT_DEAL_URL: 'EstateCypressAttribute:views:views:HUBSPOT_DEAL_URL',
    HUBSPOT_DEAL_ID: 'EstateCypressAttribute:views:views:HUBSPOT_DEAL_ID',
    ONBOARDING_INVITE_PARTNER_MODAL:
      'EstateCypressAttribute:views:views:ONBOARDING_INVITE_PARTNER_MODAL',
    ONBOARDING_CONTINUE_MODAL: 'EstateCypressAttribute:views:views:ONBOARDING_CONTINUE_MODAL',
    INACTIVITY_REENGAGEMENT_MODAL:
      'EstateCypressAttribute:views:views:INACTIVITY_REENGAGEMENT_MODAL',
    ONBOARDING_INVITE_PARTNER_SUCCESS_MODAL:
      'EstateCypressAttribute:views:views:ONBOARDING_INVITE_PARTNER_SUCCESS_MODAL',
    AMOUNT_ESTIMATES_TOOLTIP: 'EstateCypressAttribute:views:AMOUNT_ESTIMATES_TOOLTIP',
    MEMBERS_WIDGET_GO_TO_PAGE: 'EstateCypressAttribute:views:MEMBERS_WIDGET_GO_TO_PAGE',
    MEMBERS_WIDGET_DESCRIPTION: 'EstateCypressAttribute:views:MEMBERS_WIDGET_DESCRIPTION'
  },
  changeEstateModal: {
    buttons: {
      ESTATE: 'EstateCypressAttribute:changeEstateModal:ESTATE'
    },
    inputs: {},
    views: {}
  },
  estateSelection: {
    inputs: {},
    views: {},
    buttons: {
      ESTATE_SETTLEMENT_BOX: 'EstateCypressAttribute:estateSelection:views:ESTATE_SETTLEMENT_BOX',
      ESTATE_VAULT_BOX: 'EstateCypressAttribute:estateSelection:views:ESTATE_VAULT_BOX',
      ESTATE_SIGN_UP_BOX: 'EstateCypressAttribute:estateSelection:views:ESTATE_SIGN_UP_BOX'
    }
  },
  personalInformation: {
    buttons: {
      EDIT: 'EstateCypressAttribute:personalInformation:buttons:EDIT'
    },
    inputs: {},
    views: {
      EMAIL: 'EstateCypressAttribute:personalInformation:views:EMAIL'
    }
  },
  onboarding: {
    inputs: {
      EMAIL: 'EstateCypressAttribute:onboarding:EMAIL',
      FIRST_NAME: 'EstateCypressAttribute:onboarding:FIRST_NAME',
      LAST_NAME: 'EstateCypressAttribute:onboarding:LAST_NAME',
      COUNTRY: 'EstateCypressAttribute:onboarding:COUNTRY',
      JURISDICTION: 'EstateCypressAttribute:onboarding:JURISDICTION',
      DATE_OF_DEATH: 'EstateCypressAttribute:onboarding:DATE_OF_DEATH',
      IS_EXECUTOR: 'EstateCypressAttribute:onboarding:IS_EXECUTOR',
      IS_NOT_EXECUTOR: 'EstateCypressAttribute:onboarding:IS_NOT_EXECUTOR',
      AGREED_TO_TERMS: 'EstateCypressAttribute:onboarding:AGREED_TO_TERMS',
      RELATIONSHIP_TO_DECEASED: 'EstateCypressAttribute:onboarding:RELATIONSHIP_TO_DECEASED',
      COMPANY_CONSENT_CHECKBOX: 'EstateCypressAttribute:onboarding:inputs:COMPANY_CONSENT_CHECKBOX'
    },
    views: {
      BOOK_FREE_CONSULT: 'EstateCypressAttribute:onboarding:views:BOOK_FREE_CONSULT',
      LANGUAGE_BANNER: 'EstateCypressAttribute:onboarding:views:LANGUAGE_BANNER',
      STANDARD_PLAN_ONBOARDING: 'EstateCypressAttribute:onboarding:STANDARD_PLAN_ONBOARDING',
      EXECUTOR_ONBOARDING: 'EstateCypressAttribute:onboarding:EXECUTOR_ONBOARDING',
      CLEAR_VAULT_ONBOARDING: 'EstateCypressAttribute:onboarding:CLEAR_VAULT_ONBOARDING',
      INVALID_EMAIL: 'EstateCypressAttribute:onboarding:INVALID_EMAIL',
      CLEAR_VAULT_ONBOARDING_LETS_CONFIRM_TEXT:
        'EstateCypressAttribute:onboarding:CLEAR_VAULT_ONBOARDING_LETS_CONFIRM_TEXT',
      ADVISOR_INPUT_REVIEW: 'EstateCypressAttribute:views:views:ADVISOR_INPUT_REVIEW',
      CONTACTS_COLLAPSE: 'EstateCypressAttribute:onboarding:views:CONTACTS_COLLAPSE',
      SKIP_IMPORT_PREFILLING_MODAL:
        'EstateCypressAttribute:onboarding:views:SKIP_IMPORT_PREFILLING_MODAL',
      PROGRESS_BAR: 'EstateCypressAttribute:onboarding:views:PROGRESS_BAR',
      PROGRESS_BAR_LABEL: 'EstateCypressAttribute:onboarding:views:PROGRESS_BAR_LABEL',
      EP_SUPPORT_BANNER: 'EstateCypressAttribute:onboarding:views:EP_SUPPORT_BANNER',
      ROADMAP: 'EstateCypressAttribute:onboarding:views:ROADMAP',
      COMFORT_LEVEL: 'EstateCypressAttribute:onboarding:views:COMFORT_LEVEL',
      COMFORT_LEVEL_OPTIONS: 'EstateCypressAttribute:onboarding:views:COMFORT_LEVEL_OPTIONS',
      READINESS: 'EstateCypressAttribute:onboarding:views:READINESS',
      READINESS_CARD: 'EstateCypressAttribute:onboarding:views:READINESS_CARD',
      EDUCATION: 'EstateCypressAttribute:onboarding:views:EDUCATION'
    },
    buttons: {
      SKIP_LEARNING: 'EstateCypressAttribute:onboarding:buttons:SKIP_LEARNING',
      STANDARD_PLAN_NEEDS: 'EstateCypressAttribute:onboarding:STANDARD_PLAN_NEEDS',
      TALK_TO_SOMEONE: 'EstateCypressAttribute:onboarding:TALK_TO_SOMEONE',
      BOOK_FREE_CONSULT: 'EstateCypressAttribute:onboarding:buttons:BOOK_FREE_CONSULT',
      GET_STARTED: 'EstateCypressAttribute:onboarding:buttons:GET_STARTED',
      IMPORT_DATA: 'EstateCypressAttribute:onboarding:buttons:IMPORT_DATA',
      DONT_IMPORT_DATA: 'EstateCypressAttribute:onboarding:buttons:DONT_IMPORT_DATA',
      KEEP_GOING: 'EstateCypressAttribute:onboarding:buttons:KEEP_GOING',
      READINESS_READY: 'EstateCypressAttribute:onboarding:buttons:READINESS_READY',
      READINESS_LEARN: 'EstateCypressAttribute:onboarding:buttons:READINESS_LEARN',
      INVITE_PARTNER_BACK: 'EstateCypressAttribute:onboarding:buttons:INVITE_PARTNER_BACK',
      SEND_PARTNER_INVITE: 'EstateCypressAttribute:onboarding:buttons:SEND_PARTNER_INVITE',
      SKIP_PARTNER_INVITE: 'EstateCypressAttribute:onboarding:buttons:SKIP_PARTNER_INVITE',
      CONTINUE_JOURNEY_TAKE_TOUR:
        'EstateCypressAttribute:onboarding:buttons:CONTINUE_JOURNEY_TAKE_TOUR'
    },
    text: {
      RELATIONSHIP_TO_DECEASED_TEXT:
        'EstateCypressAttribute:onboarding:RELATIONSHIP_TO_DECEASED_TEXT',
      AFTERCARE_HI_TEXT: 'EstateCypressAttribute:onboarding:text:AFTERCARE_HI_TEXT'
    }
  },
  estateCloseModal: {
    buttons: {},
    inputs: {
      STATUS_FORM_SELECT: 'EstateCypressAttribute:estateCloseModal:STATUS_FORM_SELECT'
    },
    views: {}
  },
  manage: {
    views: {
      CLEAR_ESTATE_PAGE_TABLE: 'EstateCypressAttribute:CLEAR_ESTATE_PAGE_TABLE',
      CLEAR_VAULT_PAGE_TABLE: 'EstateCypressAttribute:CLEAR_VAULT_PAGE_TABLE',
      CLEAR_WILL_PAGE_TABLE: 'EstateCypressAttribute:CLEAR_WILL_PAGE_TABLE',
      CLEAR_VAULT_ASSIGN_POPOVER: 'EstateCypressAttribute:CLEAR_VAULT_ASSIGN_POPOVER',
      OVERVIEW_ESTATE_TABS: 'EstateCypressAttribute:OVERVIEW_ESTATE_TABS'
    },
    inputs: {
      SELECT_STATE_OR_PROVINCE: 'estate/manage/inputs/SELECT_STATE_OR_PROVINCE',
      RADIO_HAS_WILL: 'estate/manage/inputs/RADIO_HAS_WILL',
      RADIO_HAS_LOCATED_WILL: 'estate/manage/inputs/RADIO_HAS_LOCATED_WILL',
      DATE_OF_DEATH: 'estate/manage/inputs/DATE_OF_DEATH',
      CLEAR_ESTATE_FILTER_TOGGLE: 'estate/manage/inputs/CLEAR_ESTATE_FILTER_TOGGLE',
      CLEAR_VAULT_FILTER_TOGGLE: 'estate/manage/inputs/CLEAR_VAULT_FILTER_TOGGLE',
      CLEAR_WILL_FILTER_TOGGLE: 'estate/manage/inputs/CLEAR_WILL_FILTER_TOGGLE'
    },
    buttons: {
      LOG_IN_AS_USER: 'EstateCypressAttribute:manage:LOG_IN_AS_USER'
    }
  },
  team: {
    views: {
      PROFESSIONALS_TABLE: 'estate/team/views/PROFESSIONALS_TABLE',
      ADVISOR_TABLE: 'EstateCypressAttribute:team:ADVISOR_TABLE',
      ADVISOR_COLLAPSABLE: 'EstateCypressAttribute:team:ADVISOR_COLLAPSABLE',
      ADVISOR_MODAL: 'EstateCypressAttribute:team:ADVISOR_MODAL',
      BENEFICIARY_COLLAPSABLE: 'EstateCypressAttribute:team:BENEFICIARY_COLLAPSABLE',
      BENEFICIARY_TABLE: 'EstateCypressAttribute:team:BENEFICIARY_TABLE',
      EXECUTOR_TABLE: 'EstateCypressAttribute:team:EXECUTOR_TABLE',
      TEAM_TABS: 'EstateCypressAttribute:team:TEAM_TABS',
      ESTATE_PROFESSIONAL_ITEM: 'EstateCypressAttribute:team:ESTATE_PROFESSIONAL_ITEM',
      ESTATE_CONSULTANT_ITEM: 'EstateCypressAttribute:team:ESTATE_CONSULTANT_ITEM'
    },
    inputs: {
      PROFESSIONS: 'EstateCypressAttribute:team:PROFESSIONS',
      COMPANY: 'EstateCypressAttribute:team:COMPANY',
      TEAM: 'EstateCypressAttribute:team:TEAM',
      SEARCH_INPUT: 'EstateCypressAttribute:team:SEARCH_INPUT',
      LOCALE: 'EstateCypressAttribute:team:LOCALE'
    },
    buttons: {
      INVITE_ADVISOR: 'EstateCypressAttribute:team:INVITE_ADVISOR',
      ADD_ESTATE_MEMBER: 'EstateCypressAttribute:team:ADD_ESTATE_MEMBER',
      ADD_PROFESSIONAL_BUTTON: 'EstateCypressAttribute:team:ADD_PROFESSIONAL_BUTTON',
      ASSIGN_TRIGGER: 'EstateCypressAttribute:team:ASSIGN_TRIGGER'
    }
  },
  dashboard: {
    buttons: {
      GO_TO_STEP: 'estate/dashboard/buttons/GO_TO_STEP',
      LINK_BANK_ACCOUNTS: 'estate/dashboard/buttons/LINK_BANK_ACCOUNTS',
      LINK_FLINKS_ACCOUNTS: 'estate/dashboard/buttons/LINK_FLINKS_ACCOUNTS',
      LINK_INVESTMENT_ACCOUNTS: 'estate/dashboard/buttons/LINK_INVESTMENT_ACCOUNTS',
      GO_TO_UPSELL_MODAL: 'estate:dashboard:buttons:GO_TO_UPSELL_MODAL',
      GUIDANCE_LIST_GO_TO_STEP: 'estate:dashboard:buttons:GUIDANCE_LIST_GO_TO_STEP',
      BALANCE_ADD_ASSETS_BUTTON: 'estate:dashboard:buttons:BALANCE_ADD_ASSETS_BUTTON',
      BALANCE_ADD_LIABILITY_BUTTON: 'estate:dashboard:buttons:BALANCE_ADD_LIABILITY_BUTTON',
      VIEW_MEMO: 'EstateCypressAttribute:dashboard:buttons:VIEW_MEMO',
      GENERATE_MEMO: 'EstateCypressAttribute:dashboard:buttons:GENERATE_MEMO'
    },
    text: {
      GO_TO_STEP: 'estate/dashboard/text/GO_TO_STEP'
    },
    inputs: {},
    views: {
      DASHBOARD: 'estate/dashboard/views/DASHBOARD',
      DASHBOARD_BENEFICIARY: 'estate/dashboard/views/DASHBOARD_BENEFICIARY',
      DOCUMENTS: 'estate:dashboard:views:DOCUMENTS',
      BALANCE_ASSETS: 'estate/dashboard/views/BALANCE_ASSETS',
      BALANCE_WIDGET: 'estate/dashboard/views/BALANCE_WIDGET',
      BALANCE_LIABILITIES: 'estate/dashboard/views/BALANCE_LIABILITIES',
      CONNECT_FLINKS_FINANCIAL_INSTITUTION:
        'estate:dashboard:views:CONNECT_FLINKS_FINANCIAL_INSTITUTION',
      CONNECTED_FINANCIAL_INSTITUTION: 'estate/dashboard/views/CONNECTED_FINANCIAL_INSTITUTION',
      CONNECTED_FINANCIAL_INSTITUTION_TITLE:
        'estate/dashboard/views/CONNECTED_FINANCIAL_INSTITUTION_TITLE',
      CONNECT_PLAID_FINANCIAL_INSTITUTION:
        'estate:dashboard:views:CONNECT_PLAID_FINANCIAL_INSTITUTION',
      ESTATE_MEMBERS: 'estate:dashboard:views:ESTATE_MEMBERS',
      MY_CLEARESTATE_TEAM: 'estate:dashboard:views:MY_CLEARESTATE_TEAM',
      MY_CLEARESTATE_TEAM_ITEM: 'estate:dashboard:views:MY_CLEARESTATE_TEAM_ITEM',
      MESSAGES: 'estate:dashboard:views:MESSAGES',
      COMPLEXITY: 'estate:dashboard:views:COMPLEXITY',
      NEXT_STEP: 'estate:dashboard:views:NEXT_STEP',
      TOP_SUBTITLE: 'estate/dashboard/views/TOP_SUBTITLE',
      UPSELL_WIDGET: 'estate:dashboard:views:UPSELL_WIDGET',
      BENEFICIARY_WIDGET: 'estate:dashboard:views:BENEFICIARY_WIDGET',
      EXECUTORS_WIDGET: 'estate:dashboard:views:EXECUTORS_WIDGET',
      BENEFICIARY_HELP_CENTRE_WIDGET: 'estate:dashboard:views:BENEFICIARY_HELP_CENTRE_WIDGET',
      PROGRESS_WIDGET: 'estate:dashboard:views:PROGRESS_WIDGET',
      PROGRESS_INFO: 'estate:dashboard:views:PROGRESS_INFO',
      MEMBERS_WIDGET: 'estate:dashboard:views:MEMBERS_WIDGET',
      SPECIFIC_BENEFICIARY_INHERITANCE_CARD:
        'estate:dashboard:views:SPECIFIC_BENEFICIARY_INHERITANCE_CARD',
      SPECIFIC_DEPENDANT_INHERITANCE_CARD:
        'estate:dashboard:views:SPECIFIC_DEPENDANT_INHERITANCE_CARD',
      PLANNER_STANDARD_DASHBOARD_WIDGETS:
        'estate:dashboard:views:PLANNER_STANDARD_DASHBOARD_WIDGETS',
      INBOX_NOTIFICATION: 'estate:dashboard:views:INBOX_NOTIFICATION',
      GUIDED_PLAN_UPGRADE_MODAL: 'estate:dashboard:views:GUIDED_PLAN_UPGRADE_MODAL',
      MEMO_TITLE: 'EstateCypressAttribute:dashboard:views:MEMO_TITLE'
    }
  },
  standardPlan: {
    input: {},
    views: {
      VAULT_PLAN_BILLING_CARD: 'EstateCypressAttribute:standardPlan:views:VAULT_PLAN_BILLING_CARD',
      EXTRA_INFORMATION: 'EstateCypressAttribute:standardPlan:views:EXTRA_INFORMATION',
      PRICE: 'EstateCypressAttribute:standardPlan:views:PRICE',
      YEARLY_PRICE: 'EstateCypressAttribute:standardPlan:views:YEARLY_PRICE',
      RECOMMENDED_HEADER: 'EstateCypressAttribute:standardPlan:views:RECOMMENDED_HEADER',
      EXCLUSIVE_PRICE: 'EstateCypressAttribute:standardPlan:views:EXCLUSIVE_PRICE',
      IS_CLIENT_TAG: 'EstateCypressAttribute:standardPlan:views:IS_CLIENT_TAG',
      BILLING_PLAN: 'EstateCypressAttribute:standardPlan:views:BILLING_PLAN',
      NON_STANDARD_PLAN: 'EstateCypressAttribute:standardPlan:views:NON_STANDARD_PLAN',
      QUEBEC_NOTARIAL_WILL_BANNER:
        'EstateCypressAttribute:standardPlan:buttons:QUEBEC_NOTARIAL_WILL_BANNER'
    },
    buttons: {
      SELECT_STANDARD_PLAN: 'EstateCypressAttribute:standardPlan:buttons:SELECT_STANDARD_PLAN',
      SELECT_NON_STANDARD_PLAN:
        'EstateCypressAttribute:standardPlan:buttons:SELECT_NON_STANDARD_PLAN',
      CHANGE_SELECTION: 'EstateCypressAttribute:standardPlan:buttons:CHANGE_SELECTION',
      REGISTER_DISCLAIMER: 'EstateCypressAttribute:standardPlan:buttons:REGISTER_DISCLAIMER',
      QUEBEC_NOTARIAL_WILL: 'EstateCypressAttribute:standardPlan:buttons:QUEBEC_NOTARIAL_WILL'
    }
  },
  widgets: {
    views: {
      ESTATE_MEMBER_BOX_DESIGNATION_NAME:
        'EstateCypressAttribute.widgets.views.ESTATE_MEMBERS_MEMBER_BOX_DESIGNATION_NAME'
    }
  }
};
